import React from 'react';
import { graphql } from 'react-apollo';
import { Icon, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { isPassengerMoveable } from '../../../../../utils/passengersMoveableCrmStates';
import { ClaimsPassengerTicketConnection } from '../../../../../queries/ClaimsPassengerTicketConnection';

import mapConnection from '../../../../../utils/connectionMapper';

const createOptions = (
  claimsPassengerTicketConnection,
  claimCrmState,
  allClaimStates
) =>
  mapConnection(claimsPassengerTicketConnection).map(passengerTicket => {
    const {
      id,
      claimId,
      claim: { crmState },
      passengerTicket: {
        passengerFirstName,
        passengerLastName,
        passengerEmail,
        airportOrigin,
        airportDestination
      }
    } = passengerTicket;
    const text = `${passengerFirstName} ${passengerLastName}`;
    return {
      claimId,
      id,
      crmState,
      key: id + claimId,
      text,
      disabled: !isPassengerMoveable(
        claimCrmState,
        crmState,
        allClaimStates
      ),
      value: id,
      content: (
        <Dropdown.Item style={{ display: 'flex' }}>
          <div style={{ flex: 2 }}>{text}</div>
          <div style={{ flex: 1, textAlign: 'center', padding: '0 2' }}>
            {passengerEmail}
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: '0 2' }}>
            <Link to={`/claim/${claimId}`} target="_blank">
              claim: {claimId}
            </Link>
          </div>
          <div style={{ flex: 2, textAlign: 'right' }}>
            {airportOrigin.name}
            <Icon color="grey" name="arrow right" />
            {airportDestination.name}
          </div>
        </Dropdown.Item>
      )
    };
  }) || [];

const withPassengerOptions = graphql(ClaimsPassengerTicketConnection, {
  options: ({ id, flightId, affiliate, filter }) => ({
    variables: {
      assignAutoComplete: {
        claimId: id,
        flightId: flightId,
        firstAndLastName: filter,
        affiliateId: affiliate.id
      }
    }
  }),
  props: ({
    data: { claimsPassengerTicketConnection, loading, refetch },
    ownProps: { claimCrmState, allClaimStates }
  }) => ({
    loading,
    refetch,
    passengerOptions:
      claimsPassengerTicketConnection && allClaimStates
        ? createOptions(
            claimsPassengerTicketConnection,
            claimCrmState,
            allClaimStates
          )
        : []
  })
});

export default withPassengerOptions;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/AddPassenger/withPassengerOptionsQuery.js